/* Provis aesthetic JS — page curtain dismiss + magnetic primary buttons */
(function () {
  // Dismiss page-load curtain
  function dismissCurtain() {
    document.body.classList.add('pv-loaded');
    sessionStorage.setItem('pv_curtain_seen', '1');
  }
  if (sessionStorage.getItem('pv_curtain_seen') === '1') {
    dismissCurtain();
  } else {
    window.addEventListener('load', function () {
      setTimeout(dismissCurtain, 1700);
    });
  }

  // Magnetic primary button hover
  var magneticSelectors = '.pv-btn-gold, .pv-cta-buttons a.pv-btn-gold, .pv-sub__btn, .add-to-cart-button, .pv-sub-tier-btn';
  var magneticEls = document.querySelectorAll(magneticSelectors);
  magneticEls.forEach(function (btn) {
    btn.addEventListener('mousemove', function (e) {
      var rect = btn.getBoundingClientRect();
      var dx = (e.clientX - (rect.left + rect.width / 2)) * 0.18;
      var dy = (e.clientY - (rect.top + rect.height / 2)) * 0.18;
      btn.style.transform = 'translate(' + dx + 'px, ' + (dy - 2) + 'px)';
    });
    btn.addEventListener('mouseleave', function () {
      btn.style.transform = '';
    });
  });

  /* ======================================================================
     A11Y REMEDIATION (2026-04-08)
     DOM-level fixes for axe-core violations that CSS alone cannot solve.
     ====================================================================== */
  function a11yFix(root) {
    root = root || document;

    /* aria-hidden-focus — Shopify product-title ships a duplicate
       <a aria-hidden="true" href="..."> link that remains focusable.
       Also covers generic aria-hidden wrappers around focusable content. */
    root.querySelectorAll('a[aria-hidden="true"][href]').forEach(function (a) {
      a.setAttribute('tabindex', '-1');
    });
    root.querySelectorAll('[aria-hidden="true"]').forEach(function (parent) {
      if (parent.tagName === 'A') return;
      parent.querySelectorAll('a[href], button, input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])').forEach(function (f) {
        f.setAttribute('tabindex', '-1');
      });
    });

    /* aria-allowed-role — Shopify header "More" overflow emits
       <button role="listitem"> which is invalid. Strip the role; the
       parent <ul> still conveys list semantics. */
    root.querySelectorAll('button[role="listitem"]').forEach(function (b) {
      b.removeAttribute('role');
    });

    /* list — <ul part="list"> inside <overflow-list> has
       <li role="presentation"> children that break the list rule.
       Strip the invalid role from shadow & light DOM. */
    root.querySelectorAll('ul[part="list"] > [role="presentation"], overflow-list ul > [role="presentation"], overflow-list li[role="presentation"]').forEach(function (el) {
      el.removeAttribute('role');
    });
    /* Also patch overflow-list instances directly (covers shadow DOM).
       If the <ul> has non-<li> children (e.g., <accordion-custom>),
       switch its role to "none" so axe's list rule skips it. */
    root.querySelectorAll('overflow-list').forEach(function (ol) {
      var ul = ol.querySelector('ul[part="list"]');
      if (ul) {
        ul.querySelectorAll('[role="presentation"]').forEach(function (el) { el.removeAttribute('role'); });
        var hasNonLi = false;
        for (var i = 0; i < ul.children.length; i++) {
          var tag = ul.children[i].tagName;
          if (tag !== 'LI' && tag !== 'SCRIPT' && tag !== 'TEMPLATE') { hasNonLi = true; break; }
        }
        if (hasNonLi && !ul.getAttribute('role')) {
          ul.setAttribute('role', 'none');
        }
      }
      if (ol.shadowRoot) {
        ol.shadowRoot.querySelectorAll('[role="presentation"]').forEach(function (el) { el.removeAttribute('role'); });
      }
    });
    /* Also patch .facets__overflow-list direct children globally */
    root.querySelectorAll('.facets__overflow-list ul[part="list"], ul[part="list"]').forEach(function (ul) {
      var hasNonLi = false;
      for (var i = 0; i < ul.children.length; i++) {
        var tag = ul.children[i].tagName;
        if (tag !== 'LI' && tag !== 'SCRIPT' && tag !== 'TEMPLATE') { hasNonLi = true; break; }
      }
      if (hasNonLi && !ul.getAttribute('role')) ul.setAttribute('role', 'none');
    });
    /* Descend into shadow roots of all overflow-list instances */
    root.querySelectorAll('overflow-list, .facets__overflow-list').forEach(function (host) {
      var sr = host.shadowRoot;
      if (!sr) return;
      sr.querySelectorAll('ul[part="list"]').forEach(function (ul) {
        var hasNonLi = false;
        for (var i = 0; i < ul.children.length; i++) {
          var tag = ul.children[i].tagName;
          if (tag !== 'LI' && tag !== 'SCRIPT' && tag !== 'TEMPLATE') { hasNonLi = true; break; }
        }
        if (hasNonLi) ul.setAttribute('role', 'none');
        sr.querySelectorAll('[role="presentation"]').forEach(function (el) { el.removeAttribute('role'); });
      });
    });

    /* landmark-unique — duplicate announcement-bar/nav landmarks.
       Label each unlabeled one so axe can distinguish them. */
    var seen = {};
    function labelLandmark(el, base) {
      if (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby')) return;
      seen[base] = (seen[base] || 0) + 1;
      el.setAttribute('aria-label', seen[base] === 1 ? base : base + ' ' + seen[base]);
    }
    root.querySelectorAll('aside.announcement-bar').forEach(function (el) {
      labelLandmark(el, 'Announcements');
    });
    root.querySelectorAll('accordion-custom .menu__details nav, menu-drawer nav').forEach(function (el) {
      labelLandmark(el, 'Menu section');
    });
    root.querySelectorAll('accordion-custom .details-content').forEach(function (el) {
      /* These are rendered as landmark regions by axe; label them. */
      if (!el.getAttribute('role')) return;
      labelLandmark(el, 'Menu panel');
    });

    /* heading-order — where a section leads with an h3 and has no h2,
       replace the h3 element with an h2. Also catches known offenders
       by class name (popups + wholesale form) regardless of container. */
    function promoteH3(h) {
      if (!h || h.tagName !== 'H3' || h.dataset.a11yPromoted) return;
      var h2 = document.createElement('h2');
      for (var i = 0; i < h.attributes.length; i++) {
        h2.setAttribute(h.attributes[i].name, h.attributes[i].value);
      }
      h2.innerHTML = h.innerHTML;
      h2.dataset.a11yPromoted = '1';
      h.parentNode.replaceChild(h2, h);
    }
    root.querySelectorAll('section, .shopify-section').forEach(function (sec) {
      var headings = sec.querySelectorAll('h1, h2, h3, h4, h5, h6');
      if (!headings.length) return;
      var minLevel = 7;
      headings.forEach(function (h) {
        var l = parseInt(h.tagName[1], 10);
        if (l < minLevel) minLevel = l;
      });
      if (minLevel === 3) headings.forEach(promoteH3);
    });
    /* Known-offender hard promotions */
    root.querySelectorAll('h3.pv-pop__heading, h3.pv-wi__form-h').forEach(promoteH3);

    /* Skip-link target — ensure <main> has id="MainContent". */
    var main = root.querySelector ? root.querySelector('main') : null;
    if (main && !main.id) main.id = 'MainContent';

    /* html lang fallback */
    if (root === document && !document.documentElement.getAttribute('lang')) {
      document.documentElement.setAttribute('lang', 'en');
    }

    /* Icon-only buttons without accessible name */
    root.querySelectorAll('button:not([aria-label]):not([aria-labelledby])').forEach(function (b) {
      if (b.textContent.trim()) return;
      if (b.querySelector('img[alt]:not([alt=""])')) return;
      if (!b.querySelector('svg, i.icon, [class*="icon"]')) return;
      var cls = (b.className || '') + '';
      var guess =
        /close|dismiss/i.test(cls) ? 'Close' :
        /cart|bag/i.test(cls)      ? 'Cart' :
        /search/i.test(cls)        ? 'Search' :
        /menu|hamburger|nav/i.test(cls) ? 'Menu' :
        /account|user/i.test(cls)  ? 'Account' :
        /prev|back/i.test(cls)     ? 'Previous' :
        /next|forward/i.test(cls)  ? 'Next' :
        'Button';
      b.setAttribute('aria-label', guess);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { a11yFix(document); });
  } else {
    a11yFix(document);
  }
  document.addEventListener('shopify:section:load', function (e) { a11yFix(e.target); });
  var a11yMo = new MutationObserver(function () { a11yFix(document); });
  a11yMo.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { a11yMo.disconnect(); a11yFix(document); }, 5000);
})();

// ── Coffee carousel tile uniformity + detail line styling ──
(function() {
  var css = [
    '.pv-cc__track { align-items: stretch !important; }',
    '.pv-cc__card-foot { margin-top: auto !important; }',
    '.pv-cc__card-info { display: flex !important; flex-direction: column !important; flex: 1 !important; }',
    '.pv-cc__card { display: flex !important; flex-direction: column !important; }',
    '.pv-cc__card-origin { white-space: normal !important; overflow: visible !important; text-overflow: clip !important; }',
    '.pv-cc__card-name { display: block !important; -webkit-line-clamp: unset !important; height: auto !important; overflow: visible !important; }',
    '.pv-cc__card-notes { display: block !important; -webkit-line-clamp: unset !important; height: auto !important; overflow: visible !important; }',
  ].join('\n');
  var s = document.createElement('style');
  s.textContent = css;
  document.head.appendChild(s);
})();

// ── Footer uniform dark blue (injected via JS to bypass FPC) ──
(function() {
  var g = document.querySelector('.shopify-section-group-footer-group');
  if (!g) return;
  var css = '.shopify-section-group-footer-group,' +
    '.shopify-section.shopify-section-group-footer-group,' +
    '.shopify-section-group-footer-group .shopify-section,' +
    '.shopify-section-group-footer-group > *,' +
    '.shopify-section-group-footer-group .section-background,' +
    '.shopify-section-group-footer-group .footer-content,' +
    '.shopify-section-group-footer-group [class*="color-scheme"],' +
    '.shopify-section-group-footer-group [class*="footer"]' +
    '{ background: #0d0f18 !important; background-color: #0d0f18 !important; }';
  // Also force via inline style on every descendant to beat any specificity
  g.style.setProperty('background-color', '#0d0f18', 'important');
  g.querySelectorAll('*').forEach(function(el) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA|STYLE|SCRIPT|SVG|PATH)$/.test(el.tagName)) return;
    el.style.setProperty('background-color', '#0d0f18', 'important');
  });
  var s = document.createElement('style');
  s.textContent = css;
  document.head.appendChild(s);
})();

// ── Policy page brand styling (injected via JS because Shopify's
//    FPC caches policy page HTML aggressively and blocks CSS changes
//    from theme.liquid for extended periods) ──
(function() {
  if (!document.querySelector('.shopify-policy__container')) return;
  var css = [
    '.shopify-policy__container { max-width: 780px !important; margin: 0 auto !important; padding: clamp(48px,8vh,80px) 24px !important; }',
    '.shopify-policy__title { font-family: "Tiller", Georgia, serif !important; font-weight: 700 !important; font-size: clamp(2.2rem,5vw,3.4rem) !important; color: #F8FAEF !important; background: #222432 !important; margin: 0 -24px 40px !important; padding: clamp(60px,10vh,100px) 24px clamp(48px,8vh,80px) !important; text-align: center !important; max-width: none !important; text-shadow: 0 2px 16px rgba(0,0,0,0.3) !important; position: relative !important; }',
    '.shopify-policy__body, .shopify-policy__body p, .shopify-policy__body li { font-family: "Tiller", serif !important; font-size: 1rem !important; line-height: 1.75 !important; color: rgba(34,36,50,0.78) !important; }',
    '.shopify-policy__body h2 { font-family: "Tiller", Georgia, serif !important; font-weight: 700 !important; font-size: 1.6rem !important; color: #222432 !important; margin-top: 2em !important; margin-bottom: 0.75em !important; padding-bottom: 8px !important; border-bottom: 1px solid rgba(185,169,119,0.25) !important; }',
    '.shopify-policy__body h3 { font-family: "Tiller", Georgia, serif !important; font-weight: 700 !important; font-size: 1.25rem !important; color: #B9A977 !important; margin-top: 2em !important; margin-bottom: 0.75em !important; }',
    '.shopify-policy__body a { color: #B9A977 !important; text-decoration: underline !important; text-underline-offset: 3px !important; }',
    '.shopify-policy__body > p:first-child { font-family: "DM Sans", sans-serif !important; font-size: 0.82rem !important; color: #B9A977 !important; letter-spacing: 0.06em !important; text-transform: uppercase !important; font-weight: 600 !important; }',
  ].join('\n');
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);
})();

// Selected variant button — gold pill with navy text so label is always readable
(function(){
  var s = document.createElement('style');
  s.textContent = [
    '.variant-option__button-label__pill { background: #B9A977 !important; }',
    '.variant-option__button-label:has(:checked) { color: #222432 !important; }',
    '.variant-option__button-label:has(:checked) .variant-option__button-label__text { color: #222432 !important; }',
    '.variant-option__button-label:has(:checked):hover .variant-option__button-label__pill { background: #c9b886 !important; }',
    '.variant-option__button-label:has(:checked):hover { color: #222432 !important; }',
    '.variant-option__button-label:has(:checked):hover .variant-option__button-label__text { color: #222432 !important; }',
  ].join('\n');
  document.head.appendChild(s);
})();

// ── PDP zoom: popup modal instead of full-page takeover ──
(function(){
  var s = document.createElement('style');
  s.textContent = [
    /* Dialog as centered popup — apparel-style lightbox */
    '.dialog-zoomed-gallery__dialog { max-width: 560px !important; max-height: 80vh !important; width: calc(100vw - 80px) !important; margin: auto !important; border-radius: 8px !important; overflow: hidden !important; box-shadow: 0 16px 60px rgba(0,0,0,0.5) !important; padding: 0 !important; }',
    '.dialog-zoomed-gallery__dialog::backdrop { background: rgba(0,0,0,0.65) !important; -webkit-backdrop-filter: blur(4px) !important; backdrop-filter: blur(4px) !important; }',
    /* Single image view with scroll snap */
    '.dialog-zoomed-gallery { height: 100% !important; overflow-y: auto !important; scroll-snap-type: y mandatory !important; cursor: default !important; }',
    '.dialog-zoomed-gallery .product-media-container { scroll-snap-align: start !important; flex: 0 0 100% !important; min-height: 60vh !important; display: flex !important; align-items: center !important; justify-content: center !important; cursor: default !important; }',
    '.dialog-zoomed-gallery .product-media-container .product-media__image { object-fit: contain !important; max-height: 70vh !important; }',
    /* Close button */
    '.dialog-zoomed-gallery__close-button { position: absolute !important; top: 12px !important; right: 12px !important; z-index: 9999 !important; mix-blend-mode: normal !important; background: rgba(34,36,50,0.75) !important; border-radius: 50% !important; width: 36px !important; height: 36px !important; display: flex !important; align-items: center !important; justify-content: center !important; }',
    '.dialog-zoomed-gallery__close-button:hover { background: rgba(34,36,50,0.9) !important; }',
    /* Thumbnails strip */
    '.dialog-thumbnails-list-container { background: #fff !important; border-top: 1px solid rgba(0,0,0,0.08) !important; padding: 12px 16px !important; }',
    '.dialog-thumbnails-list__thumbnail { width: 48px !important; height: 48px !important; border-radius: 4px !important; overflow: hidden !important; opacity: 0.5 !important; transition: opacity 0.2s !important; }',
    '.dialog-thumbnails-list__thumbnail[aria-selected="true"], .dialog-thumbnails-list__thumbnail:hover { opacity: 1 !important; }',
    /* Mobile */
    '@media (max-width: 749px) { .dialog-zoomed-gallery__dialog { max-width: calc(100vw - 32px) !important; max-height: 85vh !important; border-radius: 8px !important; } .dialog-zoomed-gallery .product-media-container { min-height: 50vh !important; } }',
    /* Prevent image disappearing on hover — nuclear override */
    '.product-media-container:hover, .product-media-container:hover *, .product-media-container:hover .product-media, .product-media-container:hover .product-media__image, .product-media-container:hover img { opacity: 1 !important; visibility: visible !important; display: block !important; }',
    '.product-media-container:hover .product-media { display: flex !important; }',
    '.product-media-container__zoom-button { background: transparent !important; }',
    '.product-media-container__zoom-button:hover { background: transparent !important; }',
  ].join('\n');
  document.head.appendChild(s);
})();

// 1776044800
